'use client'

import { useEffect, useRef } from 'react'
import { getCustomCodeHtml } from '@/utils/customCodeHtml'
import type { RichTextField } from '@/types/prismic'

type CustomCodePrimary = {
  code_contents: RichTextField
}

/**
 * Re-runs inline <script> tags after React hydration.
 * Scripts in dangerouslySetInnerHTML execute on first HTML parse but their
 * event listeners are lost when React reconciles the subtree in production.
 */
function executeEmbeddedScripts(container: HTMLElement) {
  container.querySelectorAll('script').forEach((oldScript) => {
    const script = document.createElement('script')
    for (const attr of oldScript.attributes) {
      script.setAttribute(attr.name, attr.value)
    }
    script.textContent = oldScript.textContent
    oldScript.replaceWith(script)
  })
}

const CustomCodeComponent = ({ data }: { data: CustomCodePrimary }) => {
  const html = getCustomCodeHtml(data.code_contents)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const container = containerRef.current
    if (!container) return
    executeEmbeddedScripts(container)
  }, [html])

  if (!html) return null

  return <div ref={containerRef} data-custom-code dangerouslySetInnerHTML={{ __html: html }} />
}

export default CustomCodeComponent
